<template>
  <v-container>
    <h2 class="text-center mb-4">Respondiendo Evaluacion</h2>

    <v-card class="pa-4" v-if="valoracion">
      <v-row>
        <v-col cols="12" sm="6">
          <strong>Empleado:</strong> {{ valoracion.Empleado.PerNom }}
        </v-col>
        <v-col cols="12" sm="6">
          <strong>Responsable:</strong> {{ valoracion.Responsable.PerNom }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <strong>Tienda:</strong> {{ valoracion.Tienda.DirNom }}
        </v-col>
        <v-col cols="12" sm="6">
          <strong>Fecha:</strong> {{ formatDate(valoracion.FechaValoracion) }}
        </v-col>
      </v-row>
    </v-card>

    <v-form ref="form" class="mt-5">

      <!-- ==================== GRUPOS ==================== -->
      <div v-for="grupo in gruposOrdenados" :key="grupo.GrupoPreguntaValoracionId" class="mb-6">
        <!-- Título del grupo -->
        <v-card flat color="grey lighten-4" class="pa-3 mb-3">
          <span class="text-h6 font-weight-bold">
            {{ grupo.Nombre }}
          </span>
        </v-card>

        <!-- Preguntas del grupo -->

        <v-card class="pa-3 mb-3" v-for="(pregunta) in grupo.Preguntas" :key="pregunta.PreguntaValoracionId">
          <v-row align="center">
            <!-- Texto de la pregunta -->
            <v-col cols="12" sm="8" class="d-flex align-center">
              <strong>{{ pregunta.Orden }}. {{ pregunta.Texto }}</strong>
            </v-col>

            <!-- Respuesta del trabajador -->
            <v-col cols="12" sm="4">
              <v-select :items="rango10" v-model="respuestas[pregunta.PreguntaValoracionId].trabajador"
                label="Respuesta (1-10)" dense outlined />
            </v-col>
          </v-row>
        </v-card>

        <!-- Observaciones -->
        <v-card class="pa-3 mb-4">
          <div class="text-subtitle-2 mb-2">Observaciones</div>
          <v-row>
            <v-col cols="12" md="6">
              <v-textarea v-model="obsTrabajador" label="Observaciones del trabajador" auto-grow outlined dense />
            </v-col>
            <v-col cols="12" md="6">
              <v-textarea v-model="obsValorador" label="Observaciones del evaluador" auto-grow outlined dense />
            </v-col>
          </v-row>
        </v-card>
        <v-footer app padless class="elevation-2">
          <v-container fluid>
            <v-row no-gutters align="center" justify="center" class="py-2 px-3 footer-safe">
              <v-col cols="12" sm="auto" class="pa-1">
                <v-btn color="primary" small block :loading="saving" @click="onGuardar(false)">
                  Guardar y salir
                </v-btn>
              </v-col>

              <v-col cols="12" sm="auto" class="pa-1">
                <v-btn color="success" small block :loading="saving" @click="onGuardar(true)">
                  Guardar y firmar
                </v-btn>
              </v-col>

              <v-col cols="12" sm="auto" class="pa-1">
                <v-btn small block @click="salir">
                  Salir
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
      </div>>
    </v-form>

    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" top timeout="2500">
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import funcs from "../funcs";

export default {
  computed: {
    ...mapState(['urlRaiz', 'perId', 'empId']),

    gruposOrdenados() {
      const gruposMap = {};

      this.preguntas.forEach(p => {
        const gid = p.GrupoPreguntaValoracionId;

        if (!gruposMap[gid]) {
          gruposMap[gid] = {
            GrupoPreguntaValoracionId: gid,
            Nombre: p.Grupo?.Nombre || `Grupo ${gid}`,
            Preguntas: []
          };
        }

        gruposMap[gid].Preguntas.push(p);
      });

      return Object.values(gruposMap)
        .sort((a, b) => a.GrupoPreguntaValoracionId - b.GrupoPreguntaValoracionId)
        .map(g => {
          g.Preguntas.sort((a, b) => (a.Orden || 0) - (b.Orden || 0));
          return g;
        });
    }

  },
  data() {
    return {
      valoracionId: null,
      valoracion: null,
      preguntas: [],
      respuestas: {},
      rango10: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      snackbar: { visible: false, color: '', text: '' },
      saving: false,
      obsTrabajador: '',
      obsValorador: '',

    }
  },
  mounted() {
    this.valoracionId = this.$route.params.id;
    this.cargarValoracion();
  },
  methods: {
    formatDate(val) {
      return funcs.formatDate(val, true);
    },
    mostrarSnackbar(texto, tipo = 'success') {
      this.snackbar.text = texto;
      this.snackbar.color = tipo === 'error' ? 'red darken-2' : 'green darken-2';
      this.snackbar.visible = true;
    },
    cargarValoracion() {
      const token = localStorage.getItem("token");
      axios.get(this.urlRaiz + "/api/valoracion/" + this.valoracionId, {
        headers: { Authorization: token }
      }).then(res => {
        this.valoracion = res.data;
        this.obsTrabajador = this.valoracion.ObservacionesTrabajador || '';
        this.obsValorador = this.valoracion.ObservacionesValorador || '';
        this.cargarPreguntas(this.valoracion.TipoValoracion);
      });
    },
    cargarPreguntas(tipo) {
      const token = localStorage.getItem("token");
      const empId = this.empId;

      axios.get(
        `${this.urlRaiz}/api/valoracion/preguntas/${tipo}/${empId}`,//envía el empId para que muestre las preguntas que le corresponden kram
        { headers: { Authorization: token } }
      ).then(res => {
        // Filtra solo preguntas que correspondan al empId kram
        this.preguntas = res.data.filter(p => p.Grupo?.EmpId === this.empId);

        this.preguntas.forEach(p => {
          this.$set(this.respuestas, p.PreguntaValoracionId, {
            trabajador: null,
            valorador: null,
            acordada: null
          });
        });

        this.cargarRespuestasGuardadas();
      });
    },


    cargarRespuestasGuardadas() {
      const token = localStorage.getItem("token");
      axios.get(this.urlRaiz + "/api/valoracionRespuesta/by-valoracion/" + this.valoracionId, {
        headers: { Authorization: token }
      }).then(res => {
        const lista = res.data || [];
        lista.forEach(r => {
          if (!this.respuestas[r.PreguntaValoracionId]) return;
          // Solo usas trabajador, pero dejo las tres por consistencia
          this.respuestas[r.PreguntaValoracionId].trabajador = r.RespuestaTrabajador;
          this.respuestas[r.PreguntaValoracionId].valorador = r.RespuestaValorador;
          this.respuestas[r.PreguntaValoracionId].acordada = r.RespuestaAcordada;
        });
      });
    },
    toNullableInt(v) {
      const n = parseInt(v, 10);
      return Number.isNaN(n) ? null : n;
    },
    guardarRespuestas(irAFirmas) {
      const token = localStorage.getItem("token");

      this.saving = true;

      const payload = this.preguntas.map(p => ({
        ValoracionId: parseInt(this.valoracionId),
        PreguntaValoracionId: p.PreguntaValoracionId,
        RespuestaTrabajador: this.toNullableInt(this.respuestas[p.PreguntaValoracionId].trabajador),
        RespuestaValorador: null,
        RespuestaAcordada: null,
      }));

      axios.post(this.urlRaiz + "/api/valoracionRespuesta/create", payload, {
        headers: { Authorization: token }
      }).then(() => {
        this.mostrarSnackbar("Respuestas guardadas correctamente");

        if (irAFirmas) {
          // Paso a firmas (desde aquí se generará el background y luego el PDF; Respondida se marca allí)
          this.$router.push('/valoracion-firmar/' + this.valoracionId);
        } else {
          // Volver al listado, queda pendiente de firma
          this.$router.push('/valoraciones');
        }
        //this.$router.push('/valoracion-firmar/' + this.valoracionId);
      }).catch(() => {
        this.mostrarSnackbar("Error al guardar", "error");
      })
        .finally(() => {
          this.saving = false;
        });
    },

    salir() {
      this.$router.push('/valoraciones');
    },

    async onGuardar(irAFirmas) {
      const token = localStorage.getItem("token");

      // Construye el array de respuestas
      const payloadRespuestas = this.preguntas.map(p => ({
        ValoracionId: parseInt(this.valoracionId),
        PreguntaValoracionId: p.PreguntaValoracionId,
        RespuestaTrabajador: this.respuestas[p.PreguntaValoracionId].trabajador != null
          ? parseInt(this.respuestas[p.PreguntaValoracionId].trabajador) : null,
        RespuestaValorador: null, // si no usas, deja null
        RespuestaAcordada: null  // si no usas, deja null
      }));

      try {
        // Opción recomendada: endpoint único transaccional (ver backend abajo)
        await axios.post(
          `${this.urlRaiz}/api/valoracionRespuesta/save-all`,
          {
            ValoracionId: parseInt(this.valoracionId),
            ObservacionesTrabajador: this.obsTrabajador,
            ObservacionesValorador: this.obsValorador,
            Respuestas: payloadRespuestas
          },
          { headers: { Authorization: token } }
        );

        this.mostrarSnackbar("Guardado correctamente");

        if (irAFirmas) {
          this.$router.push('/valoracion-firmar/' + this.valoracionId);
        } else {
          this.$router.push('/valoraciones'); // listado
        }
      } catch (e) {
        this.mostrarSnackbar("Error al guardar", "error");
      }
    }

  }
}
</script>

<style>
@supports (padding: max(0px)) {
  .footer-safe {
    padding-bottom: max(env(safe-area-inset-bottom), 8px) !important;
  }
}
</style>
